/** Generic in-memory CRUD store for one entity type, keyed by a single ID field. */
export const createEntityStore = <T, K extends keyof T>(seed: T[], idKey: K) => {
  let records: T[] = [...seed]

  const getAll = (): T[] => records

  const find = (predicate: (item: T) => boolean): T[] => records.filter(predicate)

  const getById = (id: T[K]): T | undefined => records.find((item) => item[idKey] === id)

  const insert = (item: T): T => {
    records = [...records, item]
    return item
  }

  const update = (id: T[K], patch: Partial<T>): T | undefined => {
    let updated: T | undefined
    records = records.map((item) => {
      if (item[idKey] !== id) return item
      updated = { ...item, ...patch }
      return updated
    })
    return updated
  }

  const remove = (id: T[K]): void => {
    records = records.filter((item) => item[idKey] !== id)
  }

  return { getAll, find, getById, insert, update, remove }
}
